import apiClient from '@/services/axios'
import qs from 'qs'
import store from 'store'

const getLang = () => {
  const locale = store.get('app.settings.locale') || 'id'
  return locale.split('-')[0]
}

/**
 * 
 * @param {import('axios').AxiosRequestConfig} params 
 * @returns {import('axios').AxiosPromise}
 */
export function inventoryQueryClientRequest(params = {}) {
  return apiClient({
    baseURL: `${apiClient.defaults.baseURL}/inventoryv2/query`,
    ...params,
  })
}

export const exportInventory = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/export-inventory',
    headers: {
      'Accept-Language': getLang(),
    },
    params,
  })
}

export const checkRequestExportInventory = ({ request_id, params }) => {
  return apiClient({
    method: 'get',
    url: `inventoryv2/query/request-status/${request_id}`,
    params,
  })
}

export const getInventoryList = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/list',
    params,
  })
}

export const getInventoryListV2 = ({ business_id, workspace_id, product_id, catalog_id }) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/inventory',
    headers: {
      'Business-Id': business_id,
      'Workspace-Id': workspace_id,
    },
    params: {
      product_id: product_id,
      business_id: business_id,
      catalog_id: catalog_id,
    },
  })
}

export const getInventoryByProductId = ({ product_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventory/${product_id}`,
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const getInventoryByProductIdWithDistinctRes = ({ product_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventory/${product_id}`,
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

/**
 * 
 * @param {*} params 
 * @returns 
 */
export const getAllocationStock = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory-channel/inventory-channel/detail',
    params,
  })
}

/**
 * 
 * @param {Record<string, any>} params 
 * @returns {import('axios').AxiosPromise<import('./inventory').StockAllocationResponse>}
 */
export const getStockAllocations = (productId, { params = {}, headers = {} } = {}) => {
  return apiClient({
    method: 'GET',
    url: `/inventory-channel/allocations`,
    params: {
      ...params,
      product_id: productId || params?.product_id,
    },
    headers,
  })
}

export const saveStockAllocations = (businessId, productId, data = {}) => {
  return apiClient({
    method: 'POST',
    url: `/inventory-channel/${productId}/allocations`,
    headers: {
      'Business-Id': businessId,
    },
    data,
  })
}

export const getInventories = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory/list',
    params,
  })
}

export const getInboundList = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory/movement',
    params,
  })
}

export const getStock = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory/inventory',
    params,
  })
}

export const getUom = ({ id, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventory/productUnit/${id}`,
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const getUomBySku = ({ sku, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventory/productUnitSku/${sku}`,
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const getStockAdjustment = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/query/adjustment/list',
    params,
  })
}

export const getTransferWarehouseList = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory/transfer-warehouse',
    params,
  })
}


export const getTransferWarehouseCatalogList = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory/transfer-warehouse/catalogs',
    params,
  })
}

export const createTransferNonWms = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/transfer-warehouse/create-non-wms',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const getTransferWarehouseDetail = (id, params) => {
  return apiClient({
    method: 'get',
    url: `/inventory/transfer-warehouse/${id}`,
    params,
  })
}

export const cancelTransferNonWms = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/transfer-warehouse/cancel-non-wms',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const sendTransferNonWms = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/transfer-warehouse/send-non-wms',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const receiveTransferNonWms = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/transfer-warehouse/receive-non-wms',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const checkSyncStock = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/query/cek-sync-stock/',
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getDetailStockMovementBySKU = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/detail',
    params,
  })
}

export const getDashboardSkuAndOos = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/dash/sku',
    params,
  })
}

export const getCatalogListGR = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/catalogs',
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const getCatalogListBySKU = (params) => {
  return apiClient({
    method: 'get',
    url: 'inventoryv2/query/sku',
    headers: {
      'Business-Id': params.business_id,
    },
    params,
  })
}

export const getInventoryMovement = ({ type, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/query/movement/${type}`,
    params,
  })
}

export const getTotalInventoryMovement = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/query/movement/total',
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

/**
 * @deprecated
 * 
 * @param {*} data 
 * @returns 
 */
export const addAllocationStock = (data) => {
  return apiClient({
    method: 'post',
    url: '/inventory-channel/inventory-channel/stock-allocation',
    data,
  })
}

export const addWarehouse = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const addInbound = (data) => {
  return apiClient({
    method: 'post',
    url: '/inventory-cmd/inbound',
    data,
  })
}

export const syncStock = ({ business_id, params }) => {
  return apiClient({
    method: 'post',
    url: '/inventoryv2/cmd/sync-stock/',
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const createAdjustment = ({ data }) => {
  return apiClient({
    method: 'post',
    url: 'inventoryv2/cmd/adjustment/create',
    data,
  })
}

export const republishChannelStock = (data) => {
  return apiClient({
    method: 'post',
    url: 'inventory-channel/sync-stock',
    data,
    headers: {
      'Business-Id': data.business_id,
    },
  })
}

export const saveProductInventory = (data) => {
  return apiClient({
    method: 'post',
    url: `/inventory-cmd/product_unit`,
    data,
    params: {
      business_id: data.business_id,
    },
  })
}

export const editAdjument = (data) => {
  return apiClient({
    method: 'put',
    url: '/inventory-cmd/adjustment',
    data,
  })
}

export const addProductToWarehouse = (data) => {
  return apiClient({
    method: 'post',
    url: `/inventory-cmd/internal/inventory/added-warehouse`,
    data,
  })
}

export const checkRequestStatusAddProductToWarehouse = ({ params, id_request }) => {
  return apiClient({
    method: 'get',
    url: `/inventory-cmd/request-status/${id_request}`,
    params,
  })
}

export const getAllocationStockWithSerializer = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventory-channel/inventory-channel/detail',
    params,
    paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
  })
}

export const getDetailStockAdjustment = ({ business_id, id }) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/query/adjustment/detail/${id}`,
    headers: {
      'Business-Id': business_id,
    },
  })
}

export const getReturnReceivedList = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/query/return-received',
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getReturnReceivedDetail = ({ business_id, id }) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/query/return-received/detail/${id}`,
    headers: {
      'Business-Id': business_id,
    },
    params: { business_id },
  })
}

export const addReturnReceived = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventoryv2/cmd/return-received/create',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const cancelReturnReceived = ({ business_id, data }) => {
  return apiClient({
    method: 'put',
    url: '/inventoryv2/cmd/return-received/canceled',
    headers: {
      'Business-Id': business_id,
    },
    data,
  })
}

export const downloadTransferStockTemplate = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/cmd/transfer-warehouse/download-template',
    params,
    responseType: 'blob',
  })
}

export const importTransferStock = ({ business_id, data }) => {
  return apiClient({
    method: 'post',
    url: '/inventoryv2/cmd/transfer-warehouse/upload-non-wms',
    headers: {
      'Business-Id': business_id,
      'Content-Type': 'multipart/form-data',
    },
    data,
  })
}

export const getTransferStockImportStatus = (id) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/cmd/transfer-warehouse/upload-process/${id}`,
  })
}

export const getTransferStockImportHistory = (params) => {
  return apiClient({
    method: 'get',
    url: '/inventoryv2/cmd/transfer-warehouse/upload-history',
    params,
  })
}

export const downloadTransferStockUploadedFile = (id) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/cmd/transfer-warehouse/uploaded-file/${id}`,
    responseType: 'blob',
  })
}

export const checkCatalogWarehouse = ({ business_id, warehouse_id, is_wms, file }) => {
  const form = new FormData()
  form.append('file', file)

  return apiClient({
    method: 'post',
    url: `/inventoryv2/query/${warehouse_id}/check-catalog-warehouse`,
    headers: {
      'Content-Type': 'multipart/form-data',
      'Business-Id': business_id,
      'Accept-Language': getLang(),
    },
    data: form,
    params: { is_wms },
  })
}

export const getProductsByCatalogIds = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventoryv2/query/products_by_catalogs`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}

export const getBaseUom = ({ business_id, params }) => {
  return apiClient({
    method: 'get',
    url: `/inventory/productUnit`,
    headers: {
      'Business-Id': business_id,
    },
    params,
  })
}